module.exports = __webpack_public_path__ + "static/img/1_13_1.f71cc2c7.jpg";